/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import Activity from './activity';
import Note from './note';
import CallTabs from './CallTabs';
import EmailTabs from './emailTabs';
import FileUpload from './fileUpload';
import Documents from './documents';
import { CgAttachment } from 'react-icons/cg';
import { BiNote } from 'react-icons/bi';
import moment from 'moment';
import sweetAlert from './sweetAlert';
import { useDispatch } from 'react-redux';
import { DeleteHistory, getByIdApiActivity } from '../../Redux/CommonSlice';
import ShareFile from './shareFile';
import PdfView from './pdfView';
import FolderCreator from './creatFolder';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { moveToFolderAction } from '../../Redux/organizationSlice';
import toast from 'react-hot-toast';
import DOMPurify from 'dompurify';
import { FaRegImage } from 'react-icons/fa6';
import { PiFolderOpenBold } from 'react-icons/pi';
import { IoCall } from 'react-icons/io5';

export default function HistoryView({ Data, setLoadFirst, getAllVisible, id, identityName, showTabsOnly, showHistoryOnly }) {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('activity');
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const [editNoteData, setEditNoteData] = useState([]);
    const [editActivityData, setEditActivityData] = useState([]);
    const [pdfViewData, setPdfUrl] = useState('');
    const [copy, setCopy] = useState(false);
    const [copyUrl, setCopyUrl] = useState('');
    const [pdfOpen, setPdfOpen] = useState(false);
    const [isDoubleDropdownOpen, setIsDoubleDropdownOpen] = useState(false);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        setEditNoteData([]);
        setEditActivityData([]);
    };

    const handleCancel = () => { setEditActivityData([]); };

    const toggleDropdown = (index) => {
        if (typeof index === 'boolean') {
            setOpenDropdownIndex(null);
        } else {
            setOpenDropdownIndex(prev => prev === index ? null : index);
        }
    };

    const toggleDoubleDropdown = () => { setIsDoubleDropdownOpen(!isDoubleDropdownOpen); };

    const handleDownload = async (item) => {
        try {
            const response = await fetch(`${item.filePath}`);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", item.title);
            document.body.appendChild(link);

            link.click();

            // Clean up
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading image:", error);
        }
    };

    const shareFile = (item) => { setCopyUrl(item?.filePath); setCopy(true); };

    const pdfView = (item) => { setPdfUrl(item); setPdfOpen(true); };

    const deleteHistory = async (item) => {
        try {
            const query = { type: item.type, id: item.id };
            const result = await sweetAlert.confirm(
                "Are you sure?",
                "Are you sure you want to delete this!"
            );
            if (result.isConfirmed) {
                dispatch(DeleteHistory(query)).then((res) => {
                    if (res.payload?.status === true) {
                        sweetAlert.success("Deleted successfully");
                        setLoadFirst(true);
                        setEditNoteData([]);
                        setEditActivityData([]);
                    }
                });
            }
        } catch (error) {
            console.error("Error:", error);
            sweetAlert.error("An error occurred");
        }
    };

    const editNotes = async (item) => {
        if (item.type === "notes") {
            setEditNoteData(item);
            setActiveTab('note');
        } else {
            const res = await dispatch(getByIdApiActivity(item.id));
            const data = res.payload.data;
            setEditActivityData(data);
            setActiveTab('activity');
        }
    };

    const MoveTo = (item, itemFolder) => {
        const payload = {
            folderID: itemFolder?.folderID,
            documentID: item?.id,
            type: item?.type,
            operation: "Insert",
            userID: 1
        };

        dispatch(moveToFolderAction(payload)).then((res) => {
            if (res.payload.status === 200) {
                toggleDropdown(true);
                toggleDoubleDropdown(true);
                setLoadFirst(true);
                toast.success("Move Successfully!");
            }
        });
    };

    const renderTabs = () => (
        <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 shadow-sm rounded-2xl w-full relative p-5">
            <div className="border-b border-slate-100 dark:border-slate-800 pb-2 mb-6">
                <ul className="flex flex-wrap gap-6 text-sm font-bold text-slate-400 dark:text-slate-500 mb-0">
                    <li>
                        <button
                            onClick={() => handleTabClick('activity')}
                            className={`pb-2.5 transition-all relative ${activeTab === 'activity'
                                ? 'text-blue-600 dark:text-blue-450 font-extrabold'
                                : 'hover:text-slate-700 dark:hover:text-slate-300'
                                }`}
                        >
                            Activity
                            {activeTab === 'activity' && (
                                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-650 rounded-full"></span>
                            )}
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => handleTabClick('note')}
                            className={`pb-2.5 transition-all relative ${activeTab === 'note'
                                ? 'text-blue-600 dark:text-blue-450 font-extrabold'
                                : 'hover:text-slate-700 dark:hover:text-slate-300'
                                }`}
                        >
                            Note
                            {activeTab === 'note' && (
                                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-650 rounded-full"></span>
                            )}
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => handleTabClick('email')}
                            className={`pb-2.5 transition-all relative ${activeTab === 'email'
                                ? 'text-blue-600 dark:text-blue-450 font-extrabold'
                                : 'hover:text-slate-700 dark:hover:text-slate-300'
                                }`}
                        >
                            Email
                            {activeTab === 'email' && (
                                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-650 rounded-full"></span>
                            )}
                        </button>
                    </li>
                    {identityName !== 'lead' && (
                        <>
                            <li>
                                <button
                                    onClick={() => handleTabClick('call')}
                                    className={`pb-2.5 transition-all relative ${activeTab === 'call'
                                        ? 'text-blue-600 dark:text-blue-455 font-extrabold'
                                        : 'hover:text-slate-700 dark:hover:text-slate-300'
                                        }`}
                                >
                                    Call
                                    {activeTab === 'call' && (
                                        <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-650 rounded-full"></span>
                                    )}
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => handleTabClick('files')}
                                    className={`pb-2.5 transition-all relative ${activeTab === 'files'
                                        ? 'text-blue-600 dark:text-blue-455 font-extrabold'
                                        : 'hover:text-slate-700 dark:hover:text-slate-300'
                                        }`}
                                >
                                    Files
                                    {activeTab === 'files' && (
                                        <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-650 rounded-full"></span>
                                    )}
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => handleTabClick('documents')}
                                    className={`pb-2.5 transition-all relative ${activeTab === 'documents'
                                        ? 'text-blue-600 dark:text-blue-455 font-extrabold'
                                        : 'hover:text-slate-700 dark:hover:text-slate-300'
                                        }`}
                                >
                                    Documents
                                    {activeTab === 'documents' && (
                                        <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-650 rounded-full"></span>
                                    )}
                                </button>
                            </li>
                        </>
                    )}
                    {identityName === 'Organization' && (
                        <li>
                            <button
                                onClick={() => handleTabClick("folder")}
                                className={`pb-2.5 transition-all relative ${activeTab === "folder"
                                    ? 'text-blue-600 dark:text-blue-455 font-extrabold'
                                    : 'hover:text-slate-700 dark:hover:text-slate-300'
                                    }`}
                            >
                                Folder
                                {activeTab === 'folder' && (
                                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-650 rounded-full"></span>
                                )}
                            </button>
                        </li>
                    )}
                </ul>
            </div>
            <div>
                {activeTab === 'activity' && <Activity leadData={Data} editActivityData={editActivityData} setLoadFist={setLoadFirst} identityID={id} identityName={identityName} handleCancel={handleCancel} />}
                {activeTab === 'note' && <Note editNoteData={editNoteData} setEditNoteData={setEditNoteData} identityID={id} identityName={identityName} setLoadFirst={setLoadFirst} />}
                {activeTab === 'call' && <CallTabs />}
                {activeTab === 'email' && <EmailTabs />}
                {activeTab === 'files' && <FileUpload identityID={id} identityName={identityName} getAllVisible={getAllVisible} setLoadFirst={setLoadFirst} />}
                {activeTab === 'documents' && <Documents identityID={id} identityName={identityName} setLoadFirst={setLoadFirst} getAllVisible={getAllVisible} />}
                {activeTab === "folder" && (<FolderCreator identityID={id} identityName={identityName} setLoadFirst={setLoadFirst} getAllVisible={getAllVisible} />)}
            </div>
        </div>
    );

    const renderHistory = () => (
        <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 shadow-sm rounded-2xl w-full p-6">
            <div className="flex justify-between items-center mb-6">
                <div className="flex items-center gap-2.5">
                    <span className="w-1.5 h-6 rounded bg-indigo-600 dark:bg-indigo-400"></span>
                    <h3 className="text-lg font-bold text-slate-850 dark:text-white">History</h3>
                </div>
                <button className="px-3.5 py-1.5 text-xs font-bold text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-850 shadow-sm transition-all duration-200">
                    View All History
                </button>
            </div>

            {getAllVisible && getAllVisible.getHistory?.length > 0 ? (
                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="text-slate-400 uppercase tracking-wider text-[10px] font-bold border-b border-slate-100 dark:border-slate-800">
                                <th className="py-3.5 px-4 font-bold">Activity</th>
                                <th className="py-3.5 px-4 font-bold">Type</th>
                                <th className="py-3.5 px-4 font-bold">By</th>
                                <th className="py-3.5 px-4 font-bold">Description</th>
                                <th className="py-3.5 px-4 font-bold">Date & Time</th>
                                <th className="py-3.5 px-4 text-right font-bold">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100 dark:divide-slate-800 text-xs text-slate-700 dark:text-slate-300">
                            {getAllVisible.getHistory.map((item, index) => {
                                const sanitizedHtml = DOMPurify.sanitize(item?.title);

                                return (
                                    <tr className="hover:bg-slate-50/50 dark:hover:bg-slate-850/30 transition-colors font-medium" key={index}>
                                        <td className="py-3.5 px-4 font-bold text-slate-850 dark:text-white">
                                            <div className="flex items-center gap-2.5">
                                                <span className={`w-7 h-7 rounded-full flex items-center justify-center shadow-sm ${item.type === "document" ? "bg-blue-50 text-blue-600 dark:bg-blue-950/40 dark:text-blue-400" :
                                                    item.type === "attachment" ? "bg-indigo-50 text-indigo-650 dark:bg-indigo-950/40 dark:text-indigo-400" :
                                                        item.type === "Folder" ? "bg-emerald-50 text-emerald-600 dark:bg-emerald-950/40 dark:text-emerald-400" :
                                                            item.type === "notes" || item.type === "note" ? "bg-amber-50 text-amber-600 dark:bg-amber-950/40 dark:text-amber-400" :
                                                                "bg-purple-50 text-purple-650 dark:bg-purple-950/40 dark:text-purple-400"
                                                    }`}>
                                                    {item.type === "document" ? <CgAttachment size={12} /> :
                                                        item.type === "attachment" ? <FaRegImage size={12} /> :
                                                            item.type === "Folder" ? <PiFolderOpenBold size={12} /> :
                                                                item.type === "notes" || item.type === "note" ? <BiNote size={12} /> :
                                                                    <IoCall size={12} />}
                                                </span>
                                                <span className="capitalize">
                                                    {item.type === "notes" || item.type === "note" ? "Note" :
                                                        item.type === "Folder" ? "Folder" :
                                                            item.type === "document" ? "Document" :
                                                                item.type === "attachment" ? "Attachment" :
                                                                    item.type === "activity" ? "Activity" :
                                                                        item.type ? item.type : ""}
                                                </span>
                                            </div>
                                        </td>
                                        <td className="py-3.5 px-4">
                                            <span className={`text-[10px] font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider ${item.type === "document" ? "bg-blue-50 text-blue-650 dark:bg-blue-950/30 dark:text-blue-405" :
                                                item.type === "attachment" ? "bg-indigo-50 text-indigo-650 dark:bg-indigo-950/30 dark:text-indigo-400" :
                                                    item.type === "Folder" ? "bg-emerald-50 text-emerald-600 dark:bg-emerald-950/30 dark:text-emerald-400" :
                                                        item.type === "notes" || item.type === "note" ? "bg-amber-50 text-amber-655 dark:bg-amber-955/30 dark:text-amber-405" :
                                                            item.type === "activity" ? "bg-purple-50 text-purple-600 dark:bg-purple-950/30 dark:text-purple-400" :
                                                                "bg-slate-50 text-slate-600 dark:bg-slate-950/30 dark:text-slate-400"
                                                }`}>
                                                {item.type === "notes" || item.type === "note" ? "Note" :
                                                    item.type === "Folder" ? "Folder" :
                                                        item.type === "document" ? "Document" :
                                                            item.type === "attachment" ? "Attachment" :
                                                                item.type === "activity" ? "Activity" :
                                                                    item.type ? item.type : ""}
                                            </span>
                                        </td>
                                        <td className="py-3.5 px-4 font-bold text-slate-800 dark:text-slate-200">
                                            <div className="flex items-center gap-1.5">
                                                <div className="w-5 h-5 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-[9px] font-bold text-slate-600 dark:text-slate-400">DA</div>
                                                <span>Dhruv Admin</span>
                                            </div>
                                        </td>
                                        <td className="py-3.5 px-4 max-w-xs truncate">
                                            {item?.type !== 'notes' && (
                                                <span className="text-slate-600 dark:text-slate-350">{item?.title}</span>
                                            )}
                                            {item?.type === 'notes' && (
                                                <span className="text-slate-655 dark:text-slate-350" dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
                                            )}
                                        </td>
                                        <td className="py-3.5 px-4 text-slate-400 dark:text-slate-500">
                                            {moment(item?.updatedDate ? item?.updatedDate : item?.createdDate).format('MMMM Do YYYY, h:mm a')}
                                        </td>
                                        <td className="py-3.5 px-4 text-right relative">
                                            <button
                                                id={`dropdownMenuIconButton${index}`}
                                                onClick={() => toggleDropdown(index)}
                                                className="inline-flex items-center p-1.5 text-sm font-medium text-center text-slate-400 hover:text-slate-600 bg-transparent rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
                                                type="button"
                                            >
                                                <svg
                                                    className="w-4 h-4"
                                                    aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor"
                                                    viewBox="0 0 4 15"
                                                >
                                                    <path d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
                                                </svg>
                                            </button>
                                            {openDropdownIndex === index && (
                                                <div
                                                    id={`dropdownDots${index}`}
                                                    className="border border-slate-205 dark:border-slate-700 absolute right-0 mt-1 z-10 bg-white divide-y divide-slate-100 rounded-xl shadow-lg w-44 dark:bg-slate-800 dark:divide-slate-700 overflow-hidden"
                                                >
                                                    <ul
                                                        className="text-right text-xs font-semibold text-slate-705 dark:text-slate-200 overflow-hidden py-1 mb-0"
                                                        aria-labelledby={`dropdownMenuIconButton${index}`}
                                                    >
                                                        {(item?.type === "notes" ||
                                                            item?.type === "activity") && (
                                                                <li>
                                                                    <a
                                                                        href="#"
                                                                        className="block px-4 py-2 hover:bg-indigo-50 hover:text-indigo-650 dark:hover:bg-slate-700"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            editNotes(item);
                                                                            toggleDropdown(index);
                                                                        }}
                                                                    >
                                                                        Edit
                                                                    </a>
                                                                </li>
                                                            )}
                                                        {item?.type !== "notes" && item?.type !== "activity" && item?.type !== "Folder" && (
                                                            <li>
                                                                <a
                                                                    href="#"
                                                                    className="block px-4 py-2 hover:bg-indigo-50 hover:text-indigo-650 dark:hover:bg-slate-700"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        pdfView(item);
                                                                        toggleDropdown(index);
                                                                    }}
                                                                >
                                                                    Preview Document
                                                                </a>
                                                            </li>
                                                        )}
                                                        {item?.type !== "notes" && item?.type !== "activity" && item?.type !== "Folder" && (
                                                            <li>
                                                                <a
                                                                    href="#"
                                                                    className="block px-4 py-2 hover:bg-indigo-50 hover:text-indigo-650 dark:hover:bg-slate-700"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        shareFile(item);
                                                                        toggleDropdown(index);
                                                                    }}
                                                                >
                                                                    Share as link
                                                                </a>
                                                            </li>
                                                        )}
                                                        {item?.type !== "notes" && item?.type !== "activity" && item?.type !== "Folder" && (
                                                            <li>
                                                                <a
                                                                    href="#"
                                                                    className="block px-4 py-2 hover:bg-indigo-50 hover:text-indigo-650 dark:hover:bg-slate-700"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleDownload(item);
                                                                        toggleDropdown(index);
                                                                    }}
                                                                >
                                                                    Download PDF
                                                                </a>
                                                            </li>
                                                        )}
                                                        {identityName === 'Organization' && item?.type !== "notes" && item?.type !== "activity" && (
                                                            <li className="relative">
                                                                <button
                                                                    id="doubleDropdownButton"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        toggleDoubleDropdown();
                                                                    }}
                                                                    className="flex items-center justify-between w-full px-4 py-2 hover:bg-indigo-50 hover:text-indigo-650 dark:hover:bg-slate-700 text-right"
                                                                    type="button"
                                                                >
                                                                    <MdKeyboardArrowLeft size={16} />
                                                                    <span>Move To Folder</span>
                                                                </button>
                                                                {isDoubleDropdownOpen && (
                                                                    <div id="doubleDropdown" className="absolute right-[178px] top-0 border border-slate-200 dark:border-slate-700 z-20 bg-white divide-y divide-slate-100 rounded-xl shadow-lg w-44 dark:bg-slate-800">
                                                                        <ul className="py-1 text-[11px] text-slate-705 dark:text-slate-200 mb-0" aria-labelledby="doubleDropdownButton">
                                                                            {getAllVisible && getAllVisible.getFolders && getAllVisible.getFolders.length > 0 ? (
                                                                                (() => {
                                                                                    const filteredFolders = getAllVisible.getFolders.filter((folder) => folder.folderID !== item?.id);
                                                                                    if (filteredFolders.length > 0) {
                                                                                        return filteredFolders.map((folder) => (
                                                                                            <li key={folder.folderID}>
                                                                                                <a href="#" className="block px-4 py-1.5 capitalize text-center hover:bg-indigo-50 hover:text-indigo-650 dark:hover:bg-slate-700" onClick={(e) => { e.preventDefault(); MoveTo(item, folder); }}>
                                                                                                    {folder?.folderName}
                                                                                                </a>
                                                                                            </li>
                                                                                        ));
                                                                                    } else {
                                                                                        return <li className="text-center py-2 text-slate-400">No Folders</li>;
                                                                                    }
                                                                                })()
                                                                            ) : (
                                                                                <li className="text-center py-2 text-slate-400">No Folders</li>
                                                                            )}
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </li>
                                                        )}

                                                        <li>
                                                            <a
                                                                href="#"
                                                                className="block px-4 py-2 hover:bg-red-50 hover:text-red-650 dark:hover:bg-red-950/30 dark:hover:text-red-400 text-red-600"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    deleteHistory(item);
                                                                    toggleDropdown(index);
                                                                }}
                                                            >
                                                                Delete
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="bg-slate-50/50 dark:bg-slate-900/40 rounded-xl p-8 text-center text-slate-400 dark:text-slate-500 font-medium text-sm border border-dashed border-slate-200 dark:border-slate-800">
                    No interaction history recorded yet.
                </div>
            )}
        </div>
    );

    if (showTabsOnly) {
        return (
            <>
                {renderTabs()}
                {copy && (<ShareFile setCopy={setCopy} copyUrl={copyUrl} />)}
                {pdfOpen && (<PdfView setPdfOpen={setPdfOpen} pdfViewData={pdfViewData} />)}
            </>
        );
    }

    if (showHistoryOnly) {
        return (
            <>
                {renderHistory()}
                {copy && (<ShareFile setCopy={setCopy} copyUrl={copyUrl} />)}
                {pdfOpen && (<PdfView setPdfOpen={setPdfOpen} pdfViewData={pdfViewData} />)}
            </>
        );
    }

    return (
        <>
            {renderTabs()}
            <div className="mt-8 px-1">
                {renderHistory()}
            </div>
            {copy && (<ShareFile setCopy={setCopy} copyUrl={copyUrl} />)}
            {pdfOpen && (<PdfView setPdfOpen={setPdfOpen} pdfViewData={pdfViewData} />)}
        </>
    );
}
